// Toggle Switch Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all toggle switches
  const toggleSwitches = document.querySelectorAll('.toggle-switch');
  
  toggleSwitches.forEach(toggle => {
    // Add click event listener
    toggle.addEventListener('click', function() {
      this.classList.toggle('active');
      
      // Get the type of toggle
      const toggleType = this.dataset.toggleType || 'default';
      
      // Handle different toggle types
      switch(toggleType) {
        case 'dark-mode':
          handleDarkModeToggle(this);
          break;
        case 'language':
          handleLanguageToggle(this);
          break;
        case 'newsletter':
          handleNewsletterToggle(this);
          break;
        default:
          handleDefaultToggle(this);
      }
    });
    
    // Initialize state from localStorage
    const toggleId = toggle.dataset.toggleId;
    if (toggleId) {
      const savedState = localStorage.getItem(`toggle-${toggleId}`);
      if (savedState === 'active') {
        toggle.classList.add('active');
      }
    }
  });
});

// Dark Mode Toggle Handler
function handleDarkModeToggle(toggle) {
  const body = document.body;
  const isActive = toggle.classList.contains('active');
  
  if (isActive) {
    body.classList.add('dark-mode');
    localStorage.setItem('dark-mode', 'enabled');
  } else {
    body.classList.remove('dark-mode');
    localStorage.setItem('dark-mode', 'disabled');
  }
  
  // Save toggle state
  const toggleId = toggle.dataset.toggleId;
  if (toggleId) {
    localStorage.setItem(`toggle-${toggleId}`, isActive ? 'active' : 'inactive');
  }
}

// Language Toggle Handler
function handleLanguageToggle(toggle) {
  const isActive = toggle.classList.contains('active');
  const currentLang = isActive ? 'ar' : 'en';
  
  // Update language attribute
  document.documentElement.lang = currentLang;
  
  // Save language preference
  localStorage.setItem('preferred-language', currentLang);
  
  // Save toggle state
  const toggleId = toggle.dataset.toggleId;
  if (toggleId) {
    localStorage.setItem(`toggle-${toggleId}`, isActive ? 'active' : 'inactive');
  }
  
  // You can add more language switching logic here
  console.log(`Language switched to: ${currentLang}`);
}

// Newsletter Toggle Handler
function handleNewsletterToggle(toggle) {
  const isActive = toggle.classList.contains('active');
  
  if (isActive) {
    // Subscribe to newsletter
    subscribeToNewsletter();
  } else {
    // Unsubscribe from newsletter
    unsubscribeFromNewsletter();
  }
  
  // Save toggle state
  const toggleId = toggle.dataset.toggleId;
  if (toggleId) {
    localStorage.setItem(`toggle-${toggleId}`, isActive ? 'active' : 'inactive');
  }
}

// Default Toggle Handler
function handleDefaultToggle(toggle) {
  const isActive = toggle.classList.contains('active');
  
  // Save toggle state
  const toggleId = toggle.dataset.toggleId;
  if (toggleId) {
    localStorage.setItem(`toggle-${toggleId}`, isActive ? 'active' : 'inactive');
  }
  
  // Trigger custom event
  const event = new CustomEvent('toggleChanged', {
    detail: {
      toggle: toggle,
      isActive: isActive,
      toggleId: toggleId
    }
  });
  document.dispatchEvent(event);
}

// Newsletter functions (placeholder)
function subscribeToNewsletter() {
  // Add your newsletter subscription logic here
  console.log('Subscribed to newsletter');
  showNotification('Subscribed to newsletter!', 'success');
}

function unsubscribeFromNewsletter() {
  // Add your newsletter unsubscription logic here
  console.log('Unsubscribed from newsletter');
  showNotification('Unsubscribed from newsletter', 'info');
}

// Notification function
function showNotification(message, type = 'info') {
  // Create notification element
  const notification = document.createElement('div');
  notification.className = `notification notification--${type}`;
  notification.textContent = message;
  
  // Style the notification
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${type === 'success' ? '#4CAF50' : type === 'error' ? '#f44336' : '#2196F3'};
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    z-index: 10000;
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s ease;
  `;
  
  document.body.appendChild(notification);
  
  // Animate in
  setTimeout(() => {
    notification.style.opacity = '1';
    notification.style.transform = 'translateX(0)';
  }, 100);
  
  // Remove after 3 seconds
  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transform = 'translateX(100%)';
    setTimeout(() => {
      document.body.removeChild(notification);
    }, 300);
  }, 3000);
}

// Initialize dark mode from localStorage on page load
document.addEventListener('DOMContentLoaded', function() {
  const darkModeEnabled = localStorage.getItem('dark-mode');
  if (darkModeEnabled === 'enabled') {
    document.body.classList.add('dark-mode');
  }
});
